import { create } from 'zustand';
import { emptyPropertyForm, PropertyForm } from '../components/Steps/components/Property/constants/propertyForm';
import {
    ApplicationKeyItemsForm,
    emptyApplicationKeyItemsForm,
} from '../components/Steps/components/ApplicationAndKeyItems/constants/applicationKeyItemsForm';

/**
 * The wizard's form data, shared by the step list (progress) and each step's content (editing).
 * Lives outside any component, so every step's progress is known whether or not that step is open.
 */
interface WizardDemoState {
    property: PropertyForm;
    applicationKeyItems: ApplicationKeyItemsForm;
    updateProperty: (changes: Partial<PropertyForm>) => void;
    /** Sets the property's state; clears the county when the state changes (a county belongs to one state). */
    setPropertyState: (state: string) => void;
    updateApplicationKeyItems: (changes: Partial<ApplicationKeyItemsForm>) => void;
    reset: () => void;
}

export const useWizardDemoStore = create<WizardDemoState>((set) => ({
    property: emptyPropertyForm,
    applicationKeyItems: emptyApplicationKeyItemsForm,
    // set(state => ...) merges into the latest state, so back-to-back field changes never overwrite each other
    updateProperty: (changes) => set((state) => ({ property: { ...state.property, ...changes } })),
    setPropertyState: (propertyState) =>
        set((state) => ({
            property:
                propertyState === state.property.state
                    ? state.property
                    : { ...state.property, state: propertyState, county: '' },
        })),
    updateApplicationKeyItems: (changes) =>
        set((state) => ({ applicationKeyItems: { ...state.applicationKeyItems, ...changes } })),
    reset: () => set({ property: emptyPropertyForm, applicationKeyItems: emptyApplicationKeyItemsForm }),
}));
